import { Theme } from 'constants/theme';
import { TitleModel } from 'models';

export const adaptRatePlanTitle = (marketingChannelMessage): TitleModel => {
  if (!marketingChannelMessage) {
    return null;
  }

  return {
    text: marketingChannelMessage.value,
    uitkIcon: marketingChannelMessage.mark?.id,
    theme: Theme.NONE,
  };
};

export const getRatePlanTitle = ratePlan => {
  if (ratePlan.marketingChannelMessage?.value || ratePlan.marketingChannelMessage?.mark) {
    return ratePlan.marketingChannelMessage;
  }

  return null;
};
